export enum MessageType {
    SAMPLE_MESSAGE = "SampleMessage",
    LOCATION_MESSAGE = "LocationMessage",
    GLOBAL_MESSAGE = "GlobalMessage"
}